/*
 |--------------------------------------------------------------------------
 | Document Ready Function
 |--------------------------------------------------------------------------
 */

$(function () {
    'use strict';

    /**
     * Hidden alert.
     */
    // Hidden account ad.
    $('.ad-close').click((e) => {
        e.preventDefault();

        $('.ad-account').addClass('hidden');
    });

    // Hidden alerts.
    $('.alert-close').click((e) => {
        e.preventDefault();
        let container = $(e.currentTarget).parents('.alert-container');

        if (container) {
            container.addClass('hidden');
        }
    });

    // Hidden navigation guest options.
    $('.navigation-guest-close').click((e) => {
        e.preventDefault();
        let container = $(e.currentTarget.parentNode.parentNode);

        if (container.hasClass('navigation-guest')) {
            container.addClass('hidden');
        }
    });

    // Hidden navigation guest options.
    $('.bonus-download-close').click((e) => {
        e.preventDefault();
        let container = $(e.currentTarget).closest('.bonus-download-container');

        container.addClass('hidden');
    });

    // Available responsive functionality bonus.
    if ($(document).width() < 1024) {
        $('.bonus-mobile-hidden').addClass('hidden');

        $('.bonus-mobile-display').on('click', (e) => {
            e.preventDefault();

            $('.bonus-mobile-display').toggleClass('active');
            $('.bonus-mobile-hidden').toggleClass('hidden');
        });
    }
});
